import { createAsyncThunk } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { getDataUserId } from "../../util/manageAuth";
import { MetaProfileResponse, WhatsAppCategory } from "../../types/MetaProfileType";

export const fetchWhatsAppProfile = createAsyncThunk<
  MetaProfileResponse["data"],
  void,
  { rejectValue: string }
>("whatsapp/fetchWhatsAppProfile", async (_, thunkAPI) => {
  try {
    const userId = getDataUserId();
    if (!userId) throw new Error("User not authenticated");

    const response = await customFetch.get("/api/whatsapp/profile");
    let payload = response.data;

    if (typeof payload?.data === "string") {
      payload.data = JSON.parse(payload.data);
    }

    if (payload?.status !== 1) {
      throw new Error(payload?.error || "Failed to fetch WhatsApp profile");
    }

    if (!payload?.data) {
      throw new Error("WhatsApp profile data not found");
    }

    return payload.data as MetaProfileResponse["data"];
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch WhatsApp profile"
    );
  }
});


export const fetchWhatsAppCategories = createAsyncThunk<
  WhatsAppCategory[],
  void,
  { rejectValue: string }
>("whatsapp/fetchWhatsAppCategories", async (_, thunkAPI) => {
  try {
    const userId = getDataUserId();
    if (!userId) throw new Error("User not authenticated");

    const response = await customFetch.get("/api/whatsapp/profile/categories");
    let payload = response.data;

    if (typeof payload?.data === "string") {
      payload.data = JSON.parse(payload.data);
    }

    if (payload?.status !== 1) {
      throw new Error(payload?.error || "Failed to fetch WhatsApp categories");
    }

    if (!payload?.data) {
      throw new Error("WhatsApp categories data not found");
    }

    return payload.data as WhatsAppCategory[];
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch WhatsApp categories"
    );
  }
});